import * as React from 'react';
import {removeProject, editProjectAction, getProjectsByAssets,addNewProject,projectNewToggle} from '../../../../store/actions';
import {connect} from 'react-redux';
import {projectPreCreateingFiltering,projectPreEditingFiltering} from "../dataDef";
import {validationCheck} from "../../../helpers";

class CustomIconsAgGrid extends React.Component {

  onDelete = (id) => {
    const {removeProject, getProjectsByAssets, schema} = this.props;
    const prom = removeProject(id);
    prom.then(() => {
      getProjectsByAssets(schema.user_schema.id)
    })
  };

  onEdit = (id) => {
    const {params, editProjectAction, schema, getProjectsByAssets,projectsErrors} = this.props;
    console.log(params.data);
    const reslut = projectPreEditingFiltering(params.data, schema);
    if(!validationCheck(projectsErrors[params.data.projectIndex])){
      const prom = editProjectAction(reslut, id);

      prom.then(() => {
        getProjectsByAssets(schema.user_schema.id)
      })
    }
  };

  onAdd = () => {
    const {params, schema,getProjectsByAssets,addNewProject,projectNewToggle,projectsErrors } = this.props;
    const result = projectPreCreateingFiltering(params.data,schema);
    if(!validationCheck(projectsErrors[params.data.projectIndex])){
      addNewProject(result).then(()=> {
        projectNewToggle(false);
        getProjectsByAssets(schema.user_schema.id);
      })
    }
  };

  render() {
    const {params} = this.props;

    return params.id > -1 ? (
        <div>
          <i
            className="btn-delete fa fa-trash fa-lg "
            onClick={() => this.onDelete(params.id)}
          />
          <i
            className="btn-edit fa fa-pencil fa-lg"
            onClick={() => this.onEdit(params.id)}
          />
        </div>
      ) :
      (
        <div>
          <i
            className="btn-add fa fa-save fa-lg "
            onClick={() => this.onAdd()}
          />
        </div>
      )
  }
}

const mapStateToProps = state => {
  return {
    schema: state.schemas.schema,
    projectsErrors: state.projects.projectsErrors,
  }
};

export default connect(mapStateToProps, {removeProject, editProjectAction, getProjectsByAssets,addNewProject,projectNewToggle})(CustomIconsAgGrid);


// WEBPACK FOOTER //
// ./src/views/Projects/Projects/FieldRenderer/CustomIconsAgGrid.js